import React from 'react';
import { EntryCard } from './EntryCard';

export function ListView({ entries, duplicates, navigate }) {
  return (
    <div className="space-y-2" data-testid="kennisbank-list">
      {entries.map(entry => (
        <EntryCard key={entry.entry_id} entry={entry} duplicates={duplicates} navigate={navigate} variant="list" />
      ))}
    </div>
  );
}
